import type { ColumnMapping } from '@/components/ExcelExportModal'

export const EMPLOYEE_EXCEL_COLUMNS: ColumnMapping[] = [
    {
        header: 'employee_code',
        data_field: 'employee_code',
    },
    {
        header: 'employee_name',
        data_field: 'employee_name',
    },
    {
        header: 'department_name',
        data_field: 'department_name',
    },
    {
        header: 'position',
        data_field: 'position_name',
    },
    {
        header: 'employee_email_company',
        data_field: 'employee_email_company',
    },
    {
        header: 'employee_status',
        data_field: 'employee_status',
        formatter_type: 'employee_status',
    },
    // personal information
    {
        header: 'employee_email',
        data_field: 'employee_email',
    },
    {
        header: 'employee_phone_number',
        data_field: 'employee_phone_number',
    },
    {
        header: 'employee_birthday',
        data_field: 'employee_birthday',
    },
    {
        header: 'employees.birthplace',
        data_field: 'employee_birthplace',
    },
    {
        header: 'employee_gender',
        data_field: 'employee_gender',
    },
    {
        header: 'employees.employee_marriage',
        data_field: 'employee_marriage',
    },
    // address
    {
        header: 'country',
        data_field: 'employee_country',
    },
    {
        header: 'province',
        data_field: 'employee_city',
    },
    {
        header: 'district',
        data_field: 'employee_district',
    },
    {
        header: 'ward',
        data_field: 'employee_ward',
    },
    {
        header: 'address',
        data_field: 'employee_street',
    },
    {
        header: 'nation',
        data_field: 'employee_nation',
    },
    {
        header: 'religion',
        data_field: 'employee_religion',
    },
    {
        header: 'employees.original_place',
        data_field: 'employee_original_place',
    },
    {
        header: 'employees.employee_temporary_city',
        data_field: 'employee_temporary_city',
    },
    {
        header: 'employees.employee_temporary_district',
        data_field: 'employee_temporary_district',
    },
    {
        header: 'employees.employee_temporary_ward',
        data_field: 'employee_temporary_ward',
    },
    {
        header: 'employees.employee_temporary_street',
        data_field: 'employee_temporary_street',
    },

    // day off left
    {
        header: 'employees.day_off_left',
        data_field: 'employee_day_off_left',
    },
    {
        header: 'employees.idno',
        data_field: 'employee_idno',
    },
    {
        header: 'employees.idno_issued_by',
        data_field: 'employee_idno_issued_by',
    },
    {
        header: 'employees.idno_issued_on',
        data_field: 'employee_idno_issued_on',
        formatter_type: 'date',
        formatter_options: {
            date_format: 'DD/MM/YYYY',
        },
    },
    // university
    {
        header: 'university',
        data_field: 'employee_university',
    },
    {
        header: 'employees.employee_major',
        data_field: 'employee_major',
    },
    // bank account
    {
        header: 'employees.bank_number',
        data_field: 'employee_bank_number',
    },
    {
        header: 'employees.bank_name',
        data_field: 'employee_bank_name',
    },
    {
        header: 'employees.bank_branch',
        data_field: 'employee_bank_branch',
    },
    {
        header: 'employees.employee_personal_tax_code',
        data_field: 'employee_personal_tax_code',
    },
    {
        header: 'employees.employee_social_insurance',
        data_field: 'employee_social_insurance',
    },
    {
        header: 'employees.employee_health_insurance',
        data_field: 'employee_health_insurance',
    },
    {
        header: 'employees.employee_medical_registration_place',
        data_field: 'employee_medical_registration_place',
    },
    {
        header: 'employees.employee_start_date',
        data_field: 'employee_start_date',
        formatter_type: 'date',
        formatter_options: {
            date_format: 'DD/MM/YYYY',
        },
    },
    {
        header: 'employees.employee_end_date',
        data_field: 'employee_end_date',
        formatter_type: 'date',
        formatter_options: {
            date_format: 'DD/MM/YYYY',
        },
    },
]
